'use strict';

var _module2 = require('../module');

var _module3 = _interopRequireDefault(_module2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_module3.default.directive('responsive', function () {
    return {
        restrict: 'A',
        link: function link(scope, element, attrs) {
            element = angular.element(element);
            var breakpoints = [768, 992, 1200];
            function updateClasses() {
                var width = window.innerWidth > 0 ? window.innerWidth : screen.width;
                _.forEach(breakpoints, function (breakpoint) {
                    if (width >= breakpoint) {
                        element.addClass('min-width-' + breakpoint + 'px');
                        element.removeClass('max-width-' + (breakpoint - 1) + 'px');
                    } else {
                        element.addClass('max-width-' + (breakpoint - 1) + 'px');
                        element.removeClass('min-width-' + breakpoint + 'px');
                    }
                });
            }

            updateClasses();
            angular.element(window).bind('resize', updateClasses);
        }
    };
}); // Makes web component responsivity be based on class, not on media query. This
// allows reacting to container width rather than screen size. 
//
// Webpack config also converts the media queries into class selectors via 
// postcss.


//////////////////
// WEBPACK FOOTER
// ./src/webComponents/directives/responsive.js
// module id = 506
// module chunks = 2